// Publisher details shown in the Terms of Service, Privacy Policy, and Support
// pages. Every value marked REQUIRED must be filled in before release; the
// legal pages show a visible warning while any are blank.
export const LEGAL = {
  appName: 'Ultronic Terminal',
  companyName: 'Decisive Labs LLC',        // REQUIRED: exact legal entity name, e.g. "Example Labs LLC"
  companyAddress: '18 Tower Hill Lane, Kinnelon, New Jersey 07405',     // REQUIRED: mailing address
  governingState: 'New Jersey',     // REQUIRED: e.g. "New Jersey"
  supportEmail: 'contact@decisivelabsllc.com',       // REQUIRED: monitored support address
  privacyEmail: '',       // optional; falls back to supportEmail
  effectiveDate: 'October 31, 2026',      // REQUIRED: e.g. "November 1, 2026"
};

export const LEGAL_MISSING = ['companyName', 'companyAddress', 'governingState', 'supportEmail', 'effectiveDate']
  .filter((key) => !LEGAL[key]);

export const DISCLAIMER_SHORT =
  'For education and planning only. Not financial, investment, tax, or legal advice. Projections are hypothetical and not guarantees.';
